<div 
    (click)="onClick()"
    (keydown.enter)="onClick()"
    tabindex="0"
    [class]="(active ? 'bg-white text-black' : 'bg-semiblack text-white hover:bg-white hover:text-black' ) + ' ' + ( reverse ? 'flex-row-reverse' : 'flex-row')"
    class="flex rounded-2xl h-[100px] min-w-80 overflow-hidden cursor-pointer transition-colors group"
    role="button"
>

    <!-- CONTENT -->    
    <div class="py-3 px-4 w-4/6 flex flex-col justify-between">

        <h4 class="text-lg font-semibold line-clamp-2 mb-1">
            {{ title }} 
        </h4>
        
        <p class="text-[11px]">
            {{translation.getText('benefits', 'more_details')}}
        </p>

    </div>
    
    <!-- IMAGE -->
    <div class="w-2/6">

        @if(image) {

            <img 
                class="object-cover h-full w-full transition-transform ease-in group-hover:scale-110"
                [class]="{'scale-110': active}"
                [src]="image" 
                [alt]="title + ' Image'"
            />

        }
        <!-- LOGO FALLBACK -->
        @else {

            <div class="w-full h-full bg-black/80 flex items-center justify-center">
                <app-logo
                    class="group-hover:scale-110 transition-transform"
                    [class]="{'scale-110': active}"
                />
            </div>

        }

    </div>

</div>
